import "../../styles/menu.scss";
import CategoriesPC from "./Categories/CategoriesPC";
import HomeSection from "../../segmentedComponents/HomeSection";
import LoyaltySection from "../../segmentedComponents/LoyaltySection";
import React from "react";
import SecondaryMenu from "../../segmentedComponents/SecondaryMenu";
import { BrandUtils } from "../../utils/brandUtils";
import { MenuWrapper } from "./MenuWrapper";

const Menu = () => (
  <MenuWrapper className="menu-pc">
    <LoyaltySection />
    <HomeSection />
    {!BrandUtils.isPokerClient() && <CategoriesPC />}
    <SecondaryMenu />
    <div className="backgroundCover" />
  </MenuWrapper>
);

export default React.memo(Menu);
